const calculateVolume = (height: number): number => {
  // Real measurements of the embalse
  const baseMinorArea = 35 * 85 // Area of the lower base (m²)
  const baseMajorArea = 60 * 106 // Area of the upper base (m²)
  const totalHeight = 5 // Total height of the embalse (m)

  // Ensure the height is within valid bounds (0 to 10 meters)
  /* if (height < 0 || height > totalHeight) {
    throw new Error('Height must be between 0 and 10 meters.')
  } */

  // Calculate the area at the current height
  const currentArea = baseMinorArea + (height / totalHeight) * (baseMajorArea - baseMinorArea)

  // Calculate the volume using the original formula
  const volume = (height / 3) * (baseMinorArea + currentArea + Math.sqrt(baseMinorArea * currentArea))

  return +volume.toFixed(0) // Volume in cubic meters
}

const calculateFillingPercentage = (currentHeight: number): string => {
  // Altura máxima del embalse en este caso
  const maxHeight: number = 5

  // Calcular el volumen máximo a 5 metros de altura usando la función calculateVolume
  const maxVolume: number = calculateVolume(maxHeight)

  // Calcular el volumen actual basado en la altura proporcionada
  const currentVolume: number = calculateVolume(currentHeight)

  // Calcular el porcentaje de llenado
  const percentage: number = (currentVolume / maxVolume) * 100

  return percentage.toFixed(2) // Devuelve el porcentaje con 2 decimales como string
}

export { calculateVolume, calculateFillingPercentage }
